import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";

import styles from "./appLayout.module.css";

import SingleSideElement from "./SingleSideElement";

import { ReactComponent as Logout } from "../../Assets/icons/logout.svg";
import { ReactComponent as SettingsIcon } from "../../Assets/icons/setting.svg";
import { sidebar } from "../../data/sidebar";

const Sidebar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation().pathname;

  useEffect(() => {
    document.addEventListener("click", (e) => {
      if (e.target.className && typeof e.target.className === "string") {
        if (
          e.target?.className.includes("menu_line") ||
          e.target?.className.includes("sidebar_main") ||
          e.target?.className.includes("menu_items_container") ||
          e.target?.className.includes("menu_icon_container")
        ) {
          console.log(true);
        } else {
          setOpen(false);
        }
      }
    });
  }, []);

  return (
    <div className={styles.sidebar_container}>
      <div className={styles.sidebar_mmain}>
        <div
          className={styles.sidebar_main}
          style={{ width: open ? "200px" : "" }}
        >
          <div className={styles.sidebar_logo} style={{ padding: "20px 10px" }}>
            <img src="/logo.svg" />
          </div>
          {/* menu Items */}
          <ul className={styles.menu_items_container}>
            {sidebar.map((val, index) => {
              return (
                <SingleSideElement
                  val={val}
                  key={index}
                  location={location}
                  navigate={navigate}
                />
              );
            })}
          </ul>
          <ul className={styles.bottom_items_container}>
            <li
              className={`${styles.bottom_item} ${
                location.includes("/settings") && styles.selected
              }`}
            >
              <SettingsIcon />
              <span
                className={`${styles.sidebar_text} ${
                  true && styles.sidebar_text_show
                }`}
                style={{ textTransform: "capitalize" }}
                onClick={() => navigate("/settings")}
              >
                Settings
              </span>
            </li>
            <li
              className={styles.bottom_item}
              onClick={() => {
                localStorage.removeItem("GIRNAR_TOKEN");
                localStorage.clear();
                navigate("/");
                window.location.reload();
              }}
            >
              <Logout />
              <span
                className={`${styles.sidebar_text} ${
                  true && styles.sidebar_text_show
                }`}
                style={{ textTransform: "capitalize" }}
              >
                Logout
              </span>
            </li>
          </ul>
        </div>

        <div className={styles.sidebar_main_mob}>
          <div className={styles.mob_logo}>
            <img src="/logo.webp" style={{ height: "45px" }} />
          </div>
          <div
            className={`${styles.menu_mob_btn} ${
              open ? styles.open_menu_icon : ""
            }`}
            onClick={() => {
              setOpen((val) => !val);
            }}
          >
            <div className={styles.menu_line_one}></div>
            <div className={styles.menu_line_two}></div>
            <div className={styles.menu_line_three}></div>
          </div>
          <div
            className={`${styles.mub_overlay} ${
              open ? styles.open_menu_mob : ""
            }`}
          >
            {open && (
              <ul className={styles.menu_items_container_mob}>
                {sidebar.map((val, index) => {
                  return (
                    <li
                      key={index}
                      onClick={() => {
                        if (!val?.child) {
                          navigate(val.path);
                        }
                      }}
                      className={`${
                        val.path === location ? styles.selected : ""
                      }`}
                    >
                      {open && <FontAwesomeIcon icon={val.icon} fill="green" />}
                      <span
                        className={`${styles.sidebar_text} ${
                          open && styles.sidebar_text_show
                        }`}
                      >
                        {val.title}
                      </span>
                    </li>
                  );
                })}

                <li
                  onClick={() => {
                    localStorage.removeItem("GIRNAR_TOKEN");
                    localStorage.clear();
                    navigate("/");
                    window.location.reload();
                  }}
                >
                  {open && <FontAwesomeIcon icon={faRightFromBracket} />}
                  <span
                    className={`${styles.sidebar_text} ${
                      open && styles.sidebar_text_show
                    }`}
                  >
                    Logout
                  </span>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
